import { render } from "./user-insert.vue?vue&type=template&id=3e12ace3"
import script from "./user-insert.vue?vue&type=script&lang=js"
export * from "./user-insert.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__